import firebase from '../firebase-config'
import firebaseroot from 'firebase'

var feedbacksRef = firebase.db.ref('feedbacks')
var preguntasFeedbacksRef = firebase.db.ref('preguntasFeedback')
var plantillasRef = firebase.db.ref('plantillas')

export default {
  getById (feedbackId) {
    return feedbacksRef.child(feedbackId)
  },
  getAllFeedbacks () {
    return feedbacksRef
  },
  getPreguntasById (feedId) {
    return preguntasFeedbacksRef.child(feedId)
  },
  getFeedbacksByEditor (editor) {
    return feedbacksRef.orderByChild('editor').equalTo(editor)
  },
  getFeedbacksByOwner (owner) {
    return feedbacksRef.orderByChild('owner').equalTo(owner)
  },
  create (ownerUser, editorEmail, tipo, isEspontaneo) {
    let feedback = {}
    feedback['isEspontaneo'] = isEspontaneo || false
    feedback['created'] = firebaseroot.database.ServerValue.TIMESTAMP
    if (isEspontaneo) {
      feedback['owner'] = ownerUser
    } else {
      feedback['owner'] = ownerUser.email
    }
    feedback['editor'] = editorEmail
    feedback['tipo'] = tipo
    let feedId = feedbacksRef.push(feedback).key
    plantillasRef.child(tipo).child('preguntas').once('value', (preg) => {
      preguntasFeedbacksRef.child(feedId).set(preg.val())
    })
    return new Promise((resolve, reject) => {
      resolve(feedId)
    })
  },
  guardar (feedbackId, preguntas) {
    let preguntasDB = []
    preguntas.forEach((preg) => {
      let pregDB = {}
      pregDB['answer'] = preg.answer
      pregDB['question'] = preg.question
      if (preg.rating) {
        pregDB['rating'] = preg.rating
      }
      preguntasDB.push(pregDB)
    })
    feedbacksRef.child(feedbackId).child('completed').set(null)
    return preguntasFeedbacksRef.child(feedbackId).set(preguntasDB)
  },
  finalizar (feedback, editorUser, preguntas) {
    let preguntasDB = []
    preguntas.forEach((preg) => {
      let pregDB = {}
      pregDB['answer'] = preg.answer
      pregDB['question'] = preg.question
      if (preg.rating) {
        pregDB['rating'] = preg.rating
      }
      preguntasDB.push(pregDB)
    })
    feedbacksRef.child(feedback['.key']).child('completed').set(firebaseroot.database.ServerValue.TIMESTAMP)
    return preguntasFeedbacksRef.child(feedback['.key']).set(preguntasDB)
  },
  eliminar (feedback) {
    preguntasFeedbacksRef.child(feedback['.key']).remove()
    return feedbacksRef.child(feedback['.key']).remove()
  },
  agradecer (feedback) {
    return feedbacksRef.child(feedback['.key']).child('thanked').set(firebaseroot.database.ServerValue.TIMESTAMP)
  }
}



// WEBPACK FOOTER //
// ./src/services/feedbacks.js